import { useTranslation } from "react-i18next"
import { graphql, useFragment } from "react-relay"
import { formatDate } from "@/lib/format-date"
import { missedCallAgendaAppointmentDrawerDataFragment$key } from "@/modules/patients/agenda/teleconsultation/agenda-appointment-drawer/__generated__/missedCallAgendaAppointmentDrawerDataFragment.graphql"

const missedCallAgendaAppointmentDrawerDataFragment = graphql`
  fragment missedCallAgendaAppointmentDrawerDataFragment on Appointment {
    id
    missedCalls
  }
`

type MissedCallProps = {
  appointmentRef: missedCallAgendaAppointmentDrawerDataFragment$key
}

export const MissedCall = ({ appointmentRef }: MissedCallProps) => {
  const { missedCalls } = useFragment(missedCallAgendaAppointmentDrawerDataFragment, appointmentRef)
  const { t } = useTranslation()
  return (
    missedCalls.length > 0 && (
      <div className="animate-fade-in-top border-border bg-surface text-on-surface-subdued grid w-full content-start gap-4 rounded-xl border p-4 text-sm">
        {missedCalls.map((item, index) => (
          <div key={item} className="flex items-center justify-between">
            <span className="text-on-surface truncate text-sm font-medium">
              {t("patient.agenda.appointmentDrawer.missedCall")}
            </span>
            <span className="truncate" data-testid={`missed-call-date-${index}`}>
              {formatDate(new Date(item), "dd.MM.yyyy, HH:mm")}
            </span>
          </div>
        ))}
      </div>
    )
  )
}
